import React from "react";

const Assignment7 = ({ formStep, nextFormStep, prevFormStep, stepGoTo }) => {
  return <div>Assignment7</div>;
};

export default Assignment7;
